// extracted by mini-css-extract-plugin
export var divider = "_dc-7";
export var itemsToggle = "_dc-8";
export var mergeModal = "_dc-1";
export var optionCard = "_dc-4";
export var radioGroup = "_dc-6";
export var radioOption = "_dc-0";
export var selected = "_dc-5";
export var shipmentOptions = "_dc-2";
export var tableOptions = "_dc-3";